import { useEffect } from 'react';

const useSegmentTracking = (
  event: string,
  props: { [key: string]: any },
  loading: boolean = false
) => {
  useEffect(() => {
    if (!loading && (window as any).analytics) {
      (window as any).analytics.track(event, props);
    }
  }, [loading, event, props]);
};

export default useSegmentTracking;
